/* Бэкенд отдаёт готовые абсолютные URL (S3), а локальные превью — это уже
   blob:/data:-ссылки. Ничего доклеивать не нужно — возвращаем src как есть. */
export const resolveMediaUrl = (src: string): string => src ?? '';
